import { getIsDarkTheme } from '../selectors/getIsDarkTheme';
import { getThemeColorHexCode } from './getThemeColorHexCode';
import { getThemeHeroImage } from './getThemeHeroImage';
import { getThemeId } from '../selectors/getThemeId';
import { getThemeName } from './getThemeName';
import { getThemeRefImage } from './getThemeRefImage';
import type { ThemeMetadata } from '../schema/ThemeMetadata';
import type { ThemeId } from '../schema/ThemeId';

/**
 * Get metadata for the theme
 * @param themeId the theme id
 * @param isDarkTheme whether the theme is dark or not
 */
export const getThemeMetadata = (themeId: ThemeId, isDarkTheme: boolean): ThemeMetadata => {
    return {
        id: themeId,
        name: getThemeName(themeId),
        color: getThemeColorHexCode(themeId, isDarkTheme),
        refImage: getThemeRefImage(themeId),
        heroImage: getThemeHeroImage(themeId, isDarkTheme),
    };
};

export const getSelectedThemeMetadata = (): ThemeMetadata => {
    const themeId = getThemeId();
    const isDarkTheme = getIsDarkTheme();
    return getThemeMetadata(themeId, isDarkTheme);
};
